import api from './api';

/**
 * @param {string} levelId
 * @returns {Promise<{
 *  test_id: string
 *  is_published: boolean
 *  test_name: string
 *  skill_id: 'speaking' | 'reading_writing' | 'listening'
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-getAllTestsByLevel
 */
export default async function getTestComponentsForLevel(levelId) {
    const { data } = await api.get(`/levels/${levelId}/tests`);

    return data;
}